import { jsx } from "react/jsx-runtime";
import { grayDottedLine, blueLine, grayLine } from "./index.css.mjs";
const Line = ({
  stepIndex,
  activeStepIndex,
  maxStepIndexVisited
}) => {
  let style = grayDottedLine;
  const activeOrCompleted = stepIndex <= activeStepIndex;
  if (activeOrCompleted) {
    style = blueLine;
  }
  const previouslyVisited = stepIndex > activeStepIndex && stepIndex <= maxStepIndexVisited;
  if (previouslyVisited) {
    style = grayLine;
  }
  return /* @__PURE__ */ jsx("div", { className: style });
};
export {
  Line
};
